import { render } from "./IllustrationComponent.vue?vue&type=template&id=eb7f89d6&scoped=true"
import script from "./IllustrationComponent.vue?vue&type=script&lang=js"
export * from "./IllustrationComponent.vue?vue&type=script&lang=js"

import "./IllustrationComponent.vue?vue&type=style&index=0&id=eb7f89d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb7f89d6"]])

export default __exports__